import { authService } from '../../services/auth/authService';
import { ClearSecureStorageUseCase } from '../secureStorage/clearSecureStorageUseCase';
import { appLogger } from '@/domain/services/analytics/appLogger';

/**
 * SignOutUseCase
 * 
 * Signs out the current user from Firebase and clears all synced data.
 * Follows Flutter pattern: clear local data before sign out.
 * Returns void - throws error on failure.
 */
export class SignOutUseCase {
    async execute(): Promise<void> {
        // Step 1: Clear all synced data (local storage, cached data)
        try {
            const clearSyncedDataUseCase = new ClearSecureStorageUseCase();
            await clearSyncedDataUseCase.execute();
        } catch (error) {
            appLogger.error('Failed to clear synced data', 'SignOutUseCase.execute', { error: error as Error });
            // Continue with sign out even if clear fails
        }

        // Step 2: Sign out from Firebase
        await authService.signOut();
    }
}

export const signOutUseCase = new SignOutUseCase();
